import { Outlet } from "react-router";

import "./fonts.css";
import "./globals.css";

/**
 * Layout for /admin.
 *
 * Deliberately not the public Root. A staff member editing content has no use
 * for the site navigation, and the header's dropdown menus sit on top of the
 * editing panel. Keeping the two apart also means the admin page does not run
 * the content bootstrap loader at all: it needs none of it, and the panel
 * fetches exactly what each screen shows.
 *
 * No JSON-LD and no skip link either. This is a private tool, not a page.
 */
export function AdminRoot() {
  return (
    <div className="min-h-screen bg-white">
      <a
        href="#admin-main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-[10px] focus:bg-navy focus:px-5 focus:py-3 focus:text-white"
      >
        Skip to administration content
      </a>
      <main id="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
